import { useTranslation } from "react-i18next";
import { FormSection } from "./FormSection";
import { CategorySelector } from "../CategorySelector";

interface MenuItemCategoriesProps {
  storeId: string;
  selectedCategoryIds: string[];
  onCategoriesChange: (ids: string[]) => void;
  error?: string;
}

export function MenuItemCategories({
  storeId,
  selectedCategoryIds,
  onCategoriesChange,
  error,
}: MenuItemCategoriesProps) {
  const { t } = useTranslation();

  const safeSelectedCategoryIds = Array.isArray(selectedCategoryIds)
    ? selectedCategoryIds
    : [];

  return (
    <FormSection title="categories" htmlFor="categories" error={error}>
      {storeId ? (
        <CategorySelector
          selectedCategoryIds={safeSelectedCategoryIds}
          onCategoriesChange={onCategoriesChange}
          className={error ? "border-destructive" : ""}
          storeId={storeId}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          {t("storeSelectionError")}
        </div>
      )}
    </FormSection>
  );
}
